import { gql } from "apollo-boost"

export const getEquipmentAttachmentsByConceptId = gql`
  query getEquipmentAttachmentByConceptID($id: ID!) {
    EquipmentAttachmentsByConceptID(conceptID: $id) {
      id    
      description
      isBlocked
      concept {
        id
        name
      }
      documents {
        id,
        name,
        type,
        url
      }
    }
  }
`